import { ICellRendererParams } from '@ag-grid-community/core';
import { MenuItem } from '@material-ui/core';
import clsx from 'clsx';
import { Form, Formik } from 'formik';

import { TextField } from 'src/components/TextField';
import { BILLING_PERIODS } from 'src/services/api/productsApi';

const ONE_TIME_PAYMENT = 'One-time payment';
const ONE_TIME = 'oneTime';

export const BillingPeriodCellRenderer = (params: ICellRendererParams) => {
  const mode = params.colDef?.cellRendererParams.mode;
  const selectedInterval = params.colDef?.cellRendererParams.selectedInterval;

  if (!params.data.isNew) {
    return (
      BILLING_PERIODS.find((x) => x.value === params.data.interval)?.label ||
      '—'
    );
  }

  // Set initial interval value based on mode
  const initialInterval =
    mode === 'All' ? ONE_TIME : (params.data.interval ?? '');

  if (mode === 'OneTimeStore') return null;

  return (
    <Formik
      initialValues={{
        interval: selectedInterval ?? initialInterval,
      }}
      onSubmit={() => {}}
      enableReinitialize
    >
      {({ values, handleChange }) => (
        <Form>
          <TextField
            select
            variant="outlined"
            name="interval"
            value={values.interval}
            disabled={Boolean(selectedInterval)}
            onChange={(e) => {
              handleChange(e);
              params.node.setDataValue('interval', e.target.value);
            }}
            additionalSelectProps={{
              classes: {
                root: 'text-base text-black-heading font-normal !h-8 overflow-hidden text-ellipsis whitespace-nowrap truncate',
                disabled: 'text-hover-border',
              },
            }}
            className={clsx(
              '[&>div>svg]:h-4 [&>div>svg]:w-4 [&>div>svg]:mt-1.5 w-[90px] @xs:w-[130px] @sm:w-[160px]',
              {
                '[&>fieldset]:!border-non-hover-border':
                  Boolean(selectedInterval),
              },
            )}
          >
            {mode === 'All' && (
              <MenuItem
                className="border-b border-solid border-secondary-hover"
                value={ONE_TIME}
              >
                <span className="text-ellipsis whitespace-nowrap overflow-hidden block">
                  {ONE_TIME_PAYMENT}
                </span>
              </MenuItem>
            )}

            {BILLING_PERIODS.map((period) => (
              <MenuItem value={period.value} key={period.value}>
                {period.label}
              </MenuItem>
            ))}
          </TextField>
        </Form>
      )}
    </Formik>
  );
};
